
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 51"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.724 18.25L4.08 45.897","stroke":"#269C45","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M49 1S41.702 67.433 6.013 43.983C-17.437 8.296 49 1 49 1z","stroke":"#269C45","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.808 36.698h-11.52V25.18M30.569 27.49h-8.064v-8.064M35.18 18.265h-3.456V14.81","stroke":"#269C45","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    